<template>
  <div class="orderInfo" v-if="order_base">
    <vue-scroll :ops="ops" ref="vs">
    <div class="tit">订单信息</div>

    <ul class="orderlist">
      <li>
        <span class="listTit">订单类型：</span>
        <span class="listVal">{{order_base.business_name || '-'}}</span>
      </li>
      <li>
        <span class="listTit">实收款：</span>
        <span class="listVal" v-if="!order_base.price_real">-</span>
        <span class="listVal redText" v-else>￥{{order_base.price_real}} <b>(含运费:￥{{order_base.price_logistics}})</b></span>
      </li>
      <li>
        <span class="listTit">支付方式：</span>
        <span class="listVal">{{order_base.pay_name || '-'}}</span>
      </li>
      <li>
        <span class="listTit">是否开户：</span>
        <span class="listVal">{{order_base.open_account_status || '-'}}</span>
      </li>
      <li>
        <span class="listTit">开户类型：</span>
        <span class="listVal">{{order_base.card_type || '-'}}</span>
      </li>
      <li>
        <span class="listTit">取卡方式：</span>
        <span class="listVal">{{order_base.receive_way_name || '-'}}</span>
      </li>
      <li>
        <span class="listTit">受理会员：</span>
        <span class="listVal">{{order_base.create_member_name || '-'}}</span>
      </li>
      <li>
        <span class="listTit">受理设备：</span>
        <span class="listVal">{{order_base.device_no || '-'}}</span>
      </li>
      <li>
        <span class="listTit">订单备注：</span>
        <span class="listVal" :title="order_base.order_note">{{order_base.description || '-'}}</span>
        <!-- <span class="listVal" :title="order_base.order_note" style="vertical-align: top">{{order_base.order_note || '-'}}</span> -->
      </li>
    </ul>
    </vue-scroll>
  </div>
</template>

<script>
  export default {
    name: "orderDeCon",
    props: {
      orderItem: {
        required: true,
        type: Object
      }
    },
    data() {
      return {
        order_base: this.orderItem,
          ops: {
              scrollPanel: {
                  padding: true
              },
              rail: {
                  background: '#fff',
                  opacity: 1,
                  gutterOfSide: 0,
                  size: '8px'
              },
              bar: {
                  keepShow: true,
                  background: '#ddd',
                  size: '5px'
              },
          },//滚动条配置
      }
    },
    watch: {
      orderItem(val) {
        this.order_base = val
      }
    }
  }
</script>

<style scoped>
  .orderInfo {
    width: 27%;
    min-width: 300px;
    background: #fff;
    overflow: hidden;
  }

  .orderInfo .tit {
    font-size: 13px;
    font-weight: bold;
    color: #333;
    text-indent: 14px;
    height: 48px;
    line-height: 48px;
  }

  .orderlist li {
    padding-left: 10px;
    font-size: 12px;
  }

  .orderlist li + li {
    /* margin-top: 5px; */
    margin-top: 7px;
  }

  .orderlist li .listTit {
    display: inline-block;
    color: #7F7F7F;
    margin-right: 8px;
    width: 84px;
    text-align: right;
    vertical-align: top;
  }

  .orderlist li .listVal {
    display: inline-block;
    width: 185px;
    color: #2B2727;
    vertical-align: middle;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .orderlist li .listVal.redText {
    color: #FA6241;
  }
  .orderlist li .listVal.redText b {
    color: #2B2727;
    font-weight: normal;
  }

  .orderlist li.marginTop {
    margin-top: 15px;
  }
</style>
